// extracted by mini-css-extract-plugin
export default {"timeRow":"BookingItem_timeRow__Ki5bT","ellipsisText":"BookingItem_ellipsisText__XTK1g","eventWrapper":"BookingItem_eventWrapper__oqGHb","tag":"BookingItem_tag__9X912"};